import qs from 'qs';
import { newAPI, changeBaseNewAPI } from '../../../services';

export const fetchOsReceipt = async params => {
  const response = await newAPI.get(`/${params.userId}/establishment/${params.establishmentId}/serviceorders/${params.serviceOrderId}/print`);
  return response.data;
}

export const fetchBusinessInfo = async (userId, establishmentId) => {
  const response = await newAPI.get(`/${userId}/establishment/${establishmentId}`);
  return response.data;
}

export const fetchServiceOrder = (serviceOrderId, userId, establishmentId) => {
  const url = `/${userId}/establishment/${establishmentId}/serviceorders/${serviceOrderId}`;
  return changeBaseNewAPI('get', url).then(response => response.data);
}

export const fetchServiceOrderProduct = async (userId, establishmentId, serviceOrderServiceProductId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/serviceorders/service-product/${serviceOrderServiceProductId}`);
  return response.data;
}

export const fetchServiceOrderProductByProduct = async (userId, establishmentId, serviceOrderProductId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/serviceorders/product/${serviceOrderProductId}`);
  return response.data;
}

export const deleteServiceOrder = async (data, serviceOrderId, userId, establishmentId) => {
  const response = await changeBaseNewAPI('delete', `${userId}/establishment/${establishmentId}/serviceorders/${serviceOrderId}`, qs.stringify(data));
  return response.data;
}

export const updateServiceOrder = async (params, serviceOrderId, userId, establishmentId) => {
  let newParams = qs.stringify(params);

  newParams = params?.services?.length == 0
    ? newParams.concat('&services=[]')
    : newParams;

  const response = await changeBaseNewAPI('put', `/${userId}/establishment/${establishmentId}/serviceorders/${serviceOrderId}`, newParams);
  return response.data;
}

export const deliverReceipt = async (params, userId, establishmentId) => {
  const response = await newAPI.post(`/${userId}/establishment/${establishmentId}/serviceorders/receipt/send`, qs.stringify(params));
  return response.data;
}

export const deleteDiscount = async (userId, establishmentId, serviceOrderId) => {
  const response = await newAPI.delete(`/${userId}/establishment/${establishmentId}/serviceorders/${serviceOrderId}/discount/remove`);
  return response.data;
}

export const fetchAllServicesAndProducts = async (userId, establishmentId, serviceOrderId) => { 
  const response = await newAPI.get(`/${userId}/establishment/${establishmentId}/all-services-products/${serviceOrderId}`);
  return response.data;
}